export * from '@primeuix/themes/aura/tabmenu';
export { default } from '@primeuix/themes/aura/tabmenu';
